export default __webpack_public_path__ + "static/media/metamask-logo.75aecdca.png";